import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';
import {
  CompareFieldData,
  JobRequisition,
  OfferFull,
  OpeningAssignment,
} from '@recruitee/http/types';

@Injectable({
  providedIn: 'root',
})
export class JobRequisitionsHttpService {
  constructor(private httpApi: HttpApiService) {}

  public fetchOne$(id: number): Observable<{ requisitions: JobRequisition[] }> {
    return this.httpApi.get(`/offers/${id}/requisitions`);
  }

  public assign$(data: {
    offerId: number;
    requisitionId: number;
    copyData: boolean;
    fillOpenings?: OpeningAssignment[];
  }): Observable<{ requisition: JobRequisition }> {
    const { offerId, requisitionId, copyData, fillOpenings } = data;
    const body = { copyData, ...(fillOpenings && { fillOpenings }) };
    return this.httpApi.post(`/offers/${offerId}/requisitions/${requisitionId}/assign`, {}, body);
  }

  public assignOpenings$(data: {
    offerId: number;
    requisitionId: number;
    fillOpenings: OpeningAssignment[];
  }): Observable<{ requisition: JobRequisition }> {
    const { offerId, requisitionId, fillOpenings } = data;
    const body = { fillOpenings };
    return this.httpApi.patch(
      `/offers/${offerId}/requisitions/${requisitionId}/openings`,
      {},
      body,
    );
  }

  public unassign$({
    offerId,
    requisitionId,
  }: {
    offerId: number;
    requisitionId: number;
  }): Observable<{ requisition: JobRequisition }> {
    return this.httpApi.delete(`/offers/${offerId}/requisitions/${requisitionId}/unassign`);
  }

  public fetchDiff$(data: {
    offerId: number;
    requisitionId: number;
  }): Observable<{ fields: CompareFieldData[] }> {
    const { offerId, requisitionId } = data;
    return this.httpApi.get(`/offers/${offerId}/requisitions/${requisitionId}/diff`);
  }

  public copyData$(offerId: number, requisitionId: number): Observable<{ offer: OfferFull }> {
    return this.httpApi.patch(`/offers/${offerId}/requisitions/${requisitionId}/copy_data`);
  }
}
